var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1411_97761)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E4E4E4",
    fillOpacity: 0.49776
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5008 21.7871V21.5681C11.533 20.9202 11.7406 20.2925 12.1024 19.7496C12.7045 19.0975 13.1167 18.2983 13.2957 17.436C13.2957 16.7695 13.2957 16.0935 13.3539 15.427C13.6547 12.2184 16.8273 10 19.9611 10H20.0387C23.1725 10 26.345 12.2184 26.6555 15.427C26.7137 16.0935 26.6555 16.7695 26.704 17.436C26.8854 18.3003 27.2972 19.1019 27.8974 19.7591C28.2618 20.2972 28.4698 20.9227 28.4989 21.5681V21.7776C28.5206 22.648 28.2208 23.4968 27.6548 24.1674C26.907 24.9515 25.8921 25.4393 24.8024 25.5384C21.607 25.8812 18.383 25.8812 15.1876 25.5384C14.0991 25.435 13.0858 24.9479 12.3352 24.1674C11.778 23.4963 11.4822 22.6526 11.5008 21.7871Z",
    stroke: "#11142D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.5549 28.8518C18.0542 29.4785 18.7874 29.884 19.5922 29.9788C20.3971 30.0735 21.2072 29.8495 21.8433 29.3564C22.0389 29.2106 22.2149 29.041 22.3672 28.8518",
    stroke: "#11142D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1411_97761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.30edabf44546322488ea7e4f8b0bfd29.svg";
export { ForwardRef as ReactComponent };